import React from "react";
import { PopoverContent } from "@/components/ui/popover";

interface ProjectTypeSelectorProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectShot: () => void;
  onSelectCaseStudy: () => void;
}

export const ProjectTypeSelector: React.FC<ProjectTypeSelectorProps> = ({
  open,
  onOpenChange,
  onSelectShot,
  onSelectCaseStudy,
}) => {
  return (
    <PopoverContent
      align="end"
      side="bottom"
      className="p-6 w-[500px] shadow-2xl"
      onEscapeKeyDown={() => onOpenChange(false)}
      onPointerDownOutside={() => onOpenChange(false)}
    >
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSelectShot();
            // Close after navigation is initiated to avoid swallowing the click
            requestAnimationFrame(() => onOpenChange(false));
          }}
          className="flex flex-col items-center justify-between p-6 border-2 border-gray-200 rounded-lg hover:border-orange-500 hover:bg-orange-50 transition group"
        >
          <h3 className="font-semibold mb-2 text-gray-900">Shots</h3>

          <div className="flex items-center justify-center transition bg-[#FFEDD5] rounded-full p-4">
            <img src="/shots.svg" alt="Shots" />
          </div>

          <p className="text-xs text-gray-600 text-center leading-relaxed">
            A concise portfolio showcasing images with a description that captures the essence.
          </p>
        </button>

        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSelectCaseStudy();
            // Close after navigation is initiated
            requestAnimationFrame(() => onOpenChange(false));
          }}
          className="flex flex-col items-center justify-between gap-4 py-6 px-8 border-2 border-gray-200 rounded-lg hover:border-orange-500 hover:bg-orange-50 transition group"
        >
          <h3 className="font-semibold mb-2 text-gray-900">Case Studies</h3>

          <div className="flex items-center justify-center transition bg-[#DDE9FD] rounded-full p-4">
            <img src="/case_studies.svg" alt="Case Studies" />
          </div>

          <p className="text-xs text-gray-600 text-center leading-relaxed">
            Showcase your work with images and detailed, customizable case studies.
          </p>
        </button>
      </div>
    </PopoverContent>
  );
};

